import BookContainer from "./bookContainer";

export default function Book() {
  return (
    <div className="  flex items-end ">
      <BookContainer/>
    </div>
  );
}
